import axios from "axios";
import { fetchCollections, removeCollection } from "../actions/collection_item_action";
import {
  fetchCollectionMeta
} from "../actions/collection_item_meta_action";
import Helping from "../helpers/Helping";
import { API_URL } from "../config/urls";
import { GET_COLLECTION } from '../config/routes';
import { trackPromise } from 'react-promise-tracker';

export const getAll = (page, limit, search, sorting, sort_type) => {
  return dispatch => {
    return trackPromise(
      axios.get(API_URL.ADMIN_COLLECTION_API + GET_COLLECTION + "?page=" + page +
        "&limit=" + limit + "&search=" + search.trim() + "&sorting=" + sorting +
        "&sort_type=" + sort_type, Helping.getConfig()).then(response => {
          let total = response.data.message.total;

          dispatch(fetchCollections(response.data.message.collections));
          dispatch(
            fetchCollectionMeta({
              page: page,
              limit: limit,
              sorting: sorting,
              sort_type: sort_type,
              search: search,
              total: total,
              no_Of_pages: Math.ceil(total / limit)
            })
          );
        })
        .catch(error => {
          console.log(error);
          dispatch(fetchCollections([]));
          dispatch(
            fetchCollectionMeta({
              page: page,
              limit: limit,
              sorting: sorting,
              sort_type: sort_type,
              search: search,
              total: 0,
              no_Of_pages: page
            })
          );
          Helping.redirectToLogin(error);
        })
    )
  };
};

export const deleteCollection = id => {
  return dispatch => {
    dispatch(removeCollection(id));
  };
};


